import React from 'react';
import styled from 'styled-components';
import { Link } from '@Levi/components/common/link';
import { NavLinkProps } from './MainNavigationPropTypes';
import { Typography } from '../../common/typography/Typography.styled';
import { AppColor } from '../../../styles/colors';
import useLocale from '../../../localization/useLocale';

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const Toggle = styled(Typography.NavigationLink).attrs({ as: 'button' })`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  text-transform: uppercase;
  color: inherit;
`;

const Dropdown = styled.ul`
  position: absolute;
  top: 100%;
  right: 0;
  min-width: 3rem;
  background: ${AppColor.White};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 0.25rem 0;
  z-index: 100;
  list-style: none;

  li {
    a {
      display: block;
      padding: 0.375rem 0.75rem;
      text-transform: uppercase;
      white-space: nowrap;
      color: ${AppColor.LeviBlue};

      &:hover {
        background: ${AppColor.Neutral100};
      }
    }
  }
`;

const LocaleSelector: React.FC<{ localeLinks: NavLinkProps[] }> = ({
  localeLinks,
}) => {
  const locale = useLocale();
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (localeLinks.length === 0) return null;
  return (
    <Container ref={ref}>
      <Toggle onClick={() => setOpen((v) => !v)}>{locale} ▾</Toggle>
      {open && (
        <Dropdown>
          {localeLinks.map((link) => (
            <li key={link.label}>
              <Typography.NavigationLink
                as={Link}
                to={link.to}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </Typography.NavigationLink>
            </li>
          ))}
        </Dropdown>
      )}
    </Container>
  );
};

export default LocaleSelector;
